import { defineCustomElement, getLiteralAttribute, NectaryElement, subscribeContext, updateAttribute, updateLiteralAttribute } from '../utils';
import { DEFAULT_SIZE, sizeValues } from '../utils/size';
const templateHTML = '<style>@keyframes spinner{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}:host{display:block}:host([data-size="l"]){width:50px;height:50px;contain:strict}:host([data-size="m"]){width:24px;height:24px;contain:strict}:host([data-size="s"]){width:16px;height:16px;contain:strict}#spinner-size-l,#spinner-size-m,#spinner-size-s{display:none;will-change:transform}:host([data-size="l"])>#spinner-size-l{display:block;animation:1s linear infinite spinner}:host([data-size="m"])>#spinner-size-m{display:block;animation:1s linear infinite spinner}:host([data-size="s"])>#spinner-size-s{display:block;animation:1s linear infinite spinner}.bg{opacity:.3;stroke:var(--sinch-global-color-icon,var(--sinch-sys-color-text-default))}.fg{stroke:var(--sinch-global-color-icon,var(--sinch-sys-color-text-default))}</style><svg id="spinner-size-l" width="50" height="50" fill="none"><circle class="bg" cx="25" cy="25" r="22" stroke-width="6"/><path class="fg" d="M25 3a22 22 0 0 1 22 22" stroke-width="6" stroke-linecap="round"/></svg><svg id="spinner-size-m" width="24" height="24" fill="none"><circle class="bg" cx="12" cy="12" r="9" stroke-width="4"/><path class="fg" d="M21 12a9 9 0 0 0-9-9" stroke-width="4" stroke-linecap="round"/></svg><svg id="spinner-size-s" width="16" height="16" fill="none"><circle class="bg" cx="8" cy="8" r="6" stroke-width="2"/><path class="fg" d="M14 8a6 6 0 0 0-6-6" stroke-width="2" stroke-linecap="round"/></svg>';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-spinner', class extends NectaryElement {
  #controller = null;
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    shadowRoot.appendChild(template.content.cloneNode(true));
  }
  connectedCallback() {
    this.#controller = new AbortController();
    this.setAttribute('aria-live', 'polite');
    this.setAttribute('aria-busy', 'true');
    subscribeContext(this, 'size', this.#onContextSize, this.#controller.signal);
  }
  disconnectedCallback() {
    this.#controller.abort();
    this.#controller = null;
  }
  static get observedAttributes() {
    return ['size'];
  }
  attributeChangedCallback(name, oldVal, newVal) {
    switch (name) {
      case 'size':
        {
          updateAttribute(this, 'data-size', newVal);
          break;
        }
    }
  }
  set size(size) {
    updateLiteralAttribute(this, sizeValues, 'size', size);
  }
  get size() {
    return getLiteralAttribute(this, sizeValues, 'size', DEFAULT_SIZE);
  }
  #onContextSize = e => {
    if (this.hasAttribute('size')) {
      return;
    }
    switch (e.detail) {
      case 'l':
      case 'm':
        {
          this.setAttribute('data-size', 'm');
          break;
        }
      default:
        {
          this.setAttribute('data-size', 's');
        }
    }
  };
});